import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { OWNER_ACCOUNT_DETAILS_API } from "../apiRoutes";

const mutateAddOwnerAccountDtl = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${OWNER_ACCOUNT_DETAILS_API}`, data);
};

const useAddOwnerAccountDtlMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddOwnerAccountDtl,
    ...queryParams,
  });

export default useAddOwnerAccountDtlMutation;
